import useCms from './cms/useCms'
import type { SbglobalConfig } from '~/cms/storyblok/types/storyblok'

export default () => {
  const config = useRuntimeConfig()
  const { fetchBySlug, fetching, data } = useCms<SbglobalConfig>('globalConfig')
  const globalConfig = computed<SbglobalConfig>(
    () => data.value?.content as any,
  )

  const load = async () => {
    if (fetching.value || globalConfig.value) {
      return
    }

    // Try loading from configSet path first, fallback to default path
    const configPath = config.public.configSet || '/global-config'
    await fetchBySlug(configPath)

    // If configSet path failed, try default path
    if (!data.value && configPath !== '/global-config') {
      await fetchBySlug('/global-config')
    }
  }

  return {
    config: globalConfig,

    blackFridayLabels: computed(() => globalConfig.value?.blackFridayLabels),
    backInStock: computed(() => globalConfig.value?.backInStockFeature),
    runKameleoon: computed(() => globalConfig.value?.runKameleoon),
    htfFeatures: computed(() => globalConfig.value?.htfFeatures),
    
    fetch: load,
  }
}
